/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Showcase_TitleInputs */

const en_landing_showcase_title = /** @type {(inputs: Landing_Showcase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettering, labels and light, made with Ideogram 4.5`)
};

const zh_landing_showcase_title = /** @type {(inputs: Landing_Showcase_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`文字、标签与光影，都出自 Ideogram 4.5`)
};

/**
* | output |
* | --- |
* | "Lettering, labels and light, made with Ideogram 4.5" |
*
* @param {Landing_Showcase_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_showcase_title = /** @type {((inputs?: Landing_Showcase_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Showcase_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_showcase_title(inputs)
	return zh_landing_showcase_title(inputs)
});
export { landing_showcase_title as "landing.showcase.title" }